import {
  Component,
  OnInit,
  ɵCompiler_compileModuleSync__POST_R3__,
} from "@angular/core";
import { HttpService } from "src/app/http.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { GlobalValidationService } from "src/app/global-validation.service";
import {
  Union,
  UserType,
  Gender,
  Taluk,
  District,
  State,
  RelationType,
} from "./../agent-interface.service";
import {
  Zone,
  BoothType,
  Constituency,
  Ward,
  LocationCategory,
} from "./../../booth/booth-interface.service";
import { GlobalService } from "src/app/global.service";
import { AgentService } from "../agent.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-agent-booth-register",
  templateUrl: "./agent-booth-register.component.html",
  styleUrls: ["./agent-booth-register.component.scss"],
})
export class AgentBoothRegisterComponent implements OnInit {
  entered_agent_code: any = null;
  show_register_form = false;
  show_search_option = false;

  agent_register_form: FormGroup;
  booth_register_form: FormGroup;

  user_types: UserType[];
  unions: Union[];
  genders: Union[];
  taluks: Taluk[];
  districts: District[];
  states: State[];
  relation_types: RelationType[];

  image = null;
  aadhar_document = null;
  deposit_receipt_image = null;
  nominee_image = null;
  action = null;
  register_on_process = null;
  display_agent_form = true;
  display_business_form = true;
  // business
  booth_types: BoothType[] = [];
  zones: Zone[];
  product_price: {};
  products: any[];
  location_categories: LocationCategory[];
  wards: any;
  constituencies: Constituency[];
  showError: boolean;
  code_generated = false;
  display_product_prices = false;
  morning_routes: any;
  evening_routes: any;

  multiple_booth_list = ["new booth "];
  selected = new FormControl(0);
  agent_edit_control = {};
  business_edit_control = {};
  agent_code: any;

  agent_register_mode = false;
  booth_register_mode = false;

  selectedIndex = 3;
  constructor(
    private http: HttpService,
    private formBuilder: FormBuilder,
    private global: GlobalService,
    private sanitizer: DomSanitizer,
    private agentService: AgentService
  ) {
    // this.action = 'Register';
    this.getFormCvData();
    // agent
    this.agent_register_form = this.formBuilder.group({
      agent_id: [null, Validators.compose([])],
      agent_profile_id: [null, Validators.compose([])],
      first_name: [null, Validators.compose([Validators.required])],
      last_name: [null, Validators.compose([Validators.required])],
      union_id: [null, Validators.compose([Validators.required])],
      gender_id: [null, Validators.compose([Validators.required])],
      street: [null],
      taluk_id: [null, Validators.compose([Validators.required])],
      district_id: [null, Validators.compose([Validators.required])],
      state_id: [1, Validators.compose([Validators.required])],
      pincode: [null],
      mobile: [
        null,
        Validators.compose([
          GlobalValidationService.checkMobileNumber,
          Validators.required,
        ]),
      ],
      alternate_mobile: [null],
      agent_code: [null, Validators.compose([Validators.required])],
      communication_address: [null],
      aadhar_document: [null],
      aadhar_number: [
        null,
        Validators.compose([
          GlobalValidationService.checkAadharNumber,
          Validators.required,
        ]),
      ],
      pan_number: [
        null,
        Validators.compose([GlobalValidationService.checkPanNumber]),
      ],
      ration_card_number: [null],
      image: [null],
      bank_name: [null, Validators.compose([Validators.required])],
      branch_name: [null, Validators.compose([Validators.required])],
      ifsc_code: [null, Validators.compose([Validators.required])],
      micr_code: [null],
      account_holder_name: [null, Validators.compose([Validators.required])],
      account_number: [null, Validators.compose([Validators.required])],
      gst_number: [null],
    });
    this.agent_edit_control = {
      agent_id: true,
      agent_profile_id: true,
      first_name: true,
      last_name: true,
      union_id: true,
      gender_id: true,
      street: true,
      taluk_id: true,
      district_id: true,
      state_id: true,
      pincode: true,
      mobile: true,
      alternate_mobile: true,
      agent_code: true,
      communication_address: true,
      aadhar_document: true,
      aadhar_number: true,
      pan_number: true,
      ration_card_number: true,
      image: true,
      bank_name: true,
      branch_name: true,
      ifsc_code: true,
      micr_code: true,
      gst_number: true,
      account_holder_name: true,
      account_number: true,
      name: true,
      code: true,
      zone_id: true,
      business_type_id: true,
      constituency_id: true,
      ward_id: true,
      address: true,
      is_rural: true,
      location_category_id: true,
      business_pincode: true,
      location_category_value: true,
      landmark: true,
      working_hours_from: true,
      working_hours_to: true,
      nominee_first_name: true,
      nominee_last_name: true,
      nominee_relation_type_id: true,
      nominee_aadhar_number: true,
      nominee_phone: true,
      nominee_image: true,
      deposit_date: true,
      deposit_amount: true,
      deposit_receipt_image: true,
      morg_route_id: true,
      eve_route_id: true,
    };
    // business
    this.booth_register_form = this.formBuilder.group({
      id: [null],
      name: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      zone_id: [null, Validators.compose([Validators.required])],
      business_type_id: [null, Validators.compose([Validators.required])],
      constituency_id: [null, Validators.compose([Validators.required])],
      ward_id: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])],
      is_rural: [false],
      location_category_id: [null, Validators.compose([Validators.required])],
      pincode: [
        null,
        Validators.compose([GlobalValidationService.checkPincode]),
      ],
      location_category_value: [
        null,
        Validators.compose([Validators.required]),
      ],
      landmark: [null],
      working_hours_from: ["09:00"],
      working_hours_to: ["06:00"],
      // nominee
      nominee_first_name: [null, Validators.compose([Validators.required])],
      nominee_last_name: [null, Validators.compose([Validators.required])],
      nominee_relation_type_id: [
        null,
        Validators.compose([Validators.required]),
      ],
      nominee_aadhar_number: [
        null,
        Validators.compose([GlobalValidationService.checkNomineeAadharNumber]),
      ],
      nominee_phone: [
        null,
        Validators.compose([GlobalValidationService.checkNomineeMobileNumber]),
      ],
      nominee_image: [null],
      // deposit
      deposit_date: [null, Validators.compose([Validators.required])],
      deposit_amount: [null, Validators.compose([Validators.required])],
      deposit_receipt_image: [null],
      // routes
      morg_route_id: [null, Validators.compose([Validators.required])],
      eve_route_id: [null, Validators.compose([Validators.required])],
    });

    this.business_edit_control = {};
    if (this.agentService.get_agent_data === null) {
      this.action = "register";
      this.agent_register_mode = true;
      this.booth_register_mode = true;
      this.agent_register_form.reset();
      this.booth_register_form.reset();
      this.booth_register_form.get("working_hours_from").setValue("09:00");
      this.booth_register_form.get("working_hours_to").setValue("06:00");
      this.image = null;
      this.aadhar_document = null;
      this.nominee_image = null;
      this.image = null;
      this.code_generated = false;
    } else {
      this.action = "update";
      this.entered_agent_code = this.agentService.get_agent_data;
      this.checkAgentExists();
      this.show_search_option = true;
    }

    this.agentService.agentUpdate.subscribe((data) => {
      if (data === null) {
        this.action = "register";
        this.agent_register_mode = true;
        this.booth_register_mode = true;
        this.agent_register_form.reset();
        this.booth_register_form.reset();
        this.booth_register_form.get("working_hours_from").setValue("09:00");
        this.booth_register_form.get("working_hours_to").setValue("06:00");
        this.image = null;
        this.aadhar_document = null;
        this.nominee_image = null;
        this.image = null;
        this.code_generated = false;
      } else {
        this.action = "update";
        this.entered_agent_code = this.agentService.get_agent_data;
        this.checkAgentExists();
        this.show_search_option = true;
        // this.setupUpdateForm(relation_data);
      }
    });
  }

  ngOnInit() {}

  getFormCvData() {
    this.getUserTypes();
    this.getUnions();
    this.getGenders();
    this.getTaluks();
    this.getDistricts();
    this.getStates();
    this.getRelationTypes();
    this.getZones();
    this.getBusinessTypes();
    this.getConstituencies();
    this.getWards();
    this.getLocationCategories();
    this.getProducts();
    this.getSession();
  }

  getSession() {
    this.http.getRouteSessionWise().subscribe(
      (data) => {
        // console.log(data);
        this.morning_routes = data[1];
        this.evening_routes = data[2];
      },
      (error) => {
        console.log(error);
      }
    );
  }
  getBusinessTypes() {
    this.http.getBoothTypes().subscribe(
      (data: BoothType[]) => {
        // console.log(data);
        this.booth_types = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getConstituencies() {
    this.http.getConstituency().subscribe(
      (data: Constituency[]) => {
        // console.log(data);
        this.constituencies = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getWards() {
    this.http.getWardsBasedOnConstituency().subscribe((data: any) => {
      this.wards = data;
      // console.log(data);
    });
    // this.http.getWards().subscribe((data: Ward[]) => {
    // console.log(data);
    // }, (error) => {
    //   console.log(error);
    // });
  }

  getLocationCategories() {
    this.http.getLocationCategories().subscribe(
      (data: LocationCategory[]) => {
        // console.log(data);
        this.location_categories = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getProducts() {
    this.http.getProductwithMrp().subscribe((data: []) => {
      // console.log(data);
      this.products = data;
      this.generateProductPriceDict();
    });
  }

  generateProductPriceDict() {
    this.product_price = {};
  }

  getZones() {
    this.http.getZones().subscribe(
      (data: Zone[]) => {
        // console.log(data);
        this.zones = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUserTypes() {
    this.http.getUserTypes().subscribe(
      (data: UserType[]) => {
        // console.log(data);
        this.user_types = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUnions() {
    this.http.getUnions().subscribe(
      (data: Union[]) => {
        // console.log(data);
        this.unions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getGenders() {
    this.http.getGenders().subscribe(
      (data: Union[]) => {
        // console.log(data);
        this.genders = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getTaluks() {
    this.http.getDistrictBasedTaluks().subscribe(
      (data: Taluk[]) => {
        // console.log(data);
        this.taluks = data;
        console.info(this.taluks);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDistricts() {
    this.http.getStateBasedDistrict().subscribe(
      (data: District[]) => {
        console.info(data);
        // console.log(data);
        this.districts = data;
        console.info(this.districts);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getStates() {
    this.http.getStates().subscribe(
      (data: State[]) => {
        // console.log(data);
        this.states = data;
        console.info(this.states);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRelationTypes() {
    this.http.getRelationTypes().subscribe(
      (data: RelationType[]) => {
        // console.log(data);
        this.relation_types = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  toBase64(event) {
    console.log(event);
    console.log("to base 64");
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.image = reader.result;
      console.log(this.image);
    };
    console.log(reader.readAsDataURL(file));
  }

  toBase64AadharDocument(event) {
    console.log(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.aadhar_document = reader.result;
      console.log(this.aadhar_document);
    };
    console.log(reader.readAsDataURL(file));
  }

  toBase64AgentImage(event) {
    console.log(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.deposit_receipt_image = reader.result;
      console.log(this.deposit_receipt_image);
    };
    console.log(reader.readAsDataURL(file));
  }

  toBase64NomineeImage(event) {
    console.log(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.nominee_image = reader.result;
      console.log(this.deposit_receipt_image);
    };
    console.log(reader.readAsDataURL(file));
  }

  // on search box check
  checkAgentExists() {
    console.log(this.entered_agent_code);
    const data_dict = {
      agent_code: this.entered_agent_code,
    };
    this.multiple_booth_list = ["new booth "];
    this.http.checkAgentCode(data_dict).subscribe((data) => {
      this.agent_register_form
        .get("agent_code")
        .setValue(this.entered_agent_code);
      console.log(data);
      if (!data["status"]) {
        this.agent_register_mode = true;
        this.booth_register_mode = true;
        this.agent_register_form.reset();
        this.booth_register_form.reset();
        this.booth_register_form.get("working_hours_from").setValue("09:00");
        this.booth_register_form.get("working_hours_to").setValue("06:00");
        this.agent_register_form
          .get("agent_code")
          .setValue(this.entered_agent_code);
        this.image = null;
        this.aadhar_document = null;
        this.nominee_image = null;
        this.image = null;
        this.code_generated = false;
        this.action = "Register";
        this.show_register_form = true;
        this.agent_register_mode = true;
        this.booth_register_mode = true;
      } else {
        this.show_search_option = true;
        this.agent_register_mode = false;
        this.booth_register_mode = false;
        this.agent_register_form.reset();
        this.booth_register_form.reset();
        this.booth_register_form.get("working_hours_from").setValue("09:00");
        this.booth_register_form.get("working_hours_to").setValue("06:00");
        this.agent_register_form
          .get("agent_code")
          .setValue(this.entered_agent_code);
        this.image = null;
        this.aadhar_document = null;
        this.nominee_image = null;
        this.image = null;
        // this.code_generated = true;
        this.agent_register_mode = false;
        this.booth_register_mode = false;
        this.show_register_form = true;
        this.getFormData();
        this.agent_register_form.get("agent_id").setValue(data["agent_id"]);
      }
    });
  }

  // register_agent
  registerAgent() {
    let agent_data = Object.assign({}, this.agent_register_form.value);
    if (this.image != null) {
      agent_data.image = this.image;
    } else {
      alert("select the agent image");
      return false;
    }

    if (this.aadhar_document != null) {
      agent_data.aadhar_document = this.aadhar_document;
    } else {
      alert("select the aadhar document");
      return false;
    }

    // this.register_on_process = true;
    console.log(agent_data);
    this.http.registerAgent(agent_data).subscribe(
      (data) => {
        console.log(data);
        this.show_search_option = true;
        this.agent_register_mode = false;
        this.global.showSnakeBar(data["message"]);
        this.agent_register_form.get("agent_id").setValue(data["agent_id"]);
        this.register_on_process = false;
      },
      (error) => {
        console.log(error);
        alert(error);
        // this.agentService. is_display_agent_register_component = true;
        // this.register_on_process = false;
      }
    );
  }

  // showFullAgentForm
  showFullAgentForm() {
    this.display_agent_form = !this.display_agent_form;
  }

  showFullBusinessForm() {
    this.display_business_form = !this.display_business_form;
  }

  checkCode() {
    const data_dict = {
      business_code: this.booth_register_form.value.code,
    };
    console.log(data_dict);
    this.http.generateBoothCode(data_dict).subscribe((data) => {
      console.log(data);
      if (!data) {
        this.code_generated = true;
        this.showError = false;
      } else {
        this.showError = true;
        this.code_generated = false;
        this.booth_register_form.controls["code"].setValue(null);
      }
    });
  }

  onChange(event) {
    console.log(event);
    this.product_price = {};
    this.generateProductPriceDict();
    if (event == 4 || event == 5 || event == 6 || event == 10) {
      this.display_product_prices = true;
      if (event == 4) {
        this.products.forEach((data) => {
          if (data.private_institute_price != null) {
            this.product_price[data.id] = data.private_institute_price;
          }
        });
      }
      if (event == 5) {
        this.products.forEach((data) => {
          if (data.govt_institute_price != null) {
            this.product_price[data.id] = data.govt_institute_price;
          }
        });
      }
      if (event == 10) {
        this.products.forEach((data) => {
          if (data.govt_institute_price != null) {
            this.product_price[data.id] = data.society_price;
          }
        });
      }
      console.log(this.product_price);
    } else {
      this.display_product_prices = false;
      this.product_price = {};
    }
  }

  registerBooth() {
    if (this.deposit_receipt_image != null) {
      this.booth_register_form.value["deposit_receipt_image"] =
        this.deposit_receipt_image;
    } else {
      alert("select the deposit receipt image");
      return false;
    }
    if (this.nominee_image != null) {
      this.booth_register_form.value["nominee_image"] = this.nominee_image;
    }

    this.register_on_process = true;
    console.log(this.booth_register_form.value);
    this.booth_register_form.value["product_price"] = this.product_price;
    this.booth_register_form.value["agent_id"] =
      this.agent_register_form.value.agent_id;
    this.http
      .registerBoothWithNominee(this.booth_register_form.value)
      .subscribe(
        (data) => {
          console.log(data);

          this.booth_register_form.reset();
          this.deposit_receipt_image = null;
          this.nominee_image = null;
          this.booth_register_form.get("working_hours_from").setValue("09:00");
          this.booth_register_form.get("working_hours_to").setValue("06:00");
          this.global.showSnakeBar(data["message"]);
          this.booth_register_mode = false;
          this.register_on_process = false;
          // this.multiple_booth_list = ['new booth '];
          this.getFormData();
        },
        (error) => {
          //   console.log(error);
          alert("Error on booth register");
          this.register_on_process = false;
        }
      );
  }

  // add booth
  onTabClick(booth) {
    console.log("tab switched", booth);
    console.log("tab switched to", booth.tab.textLabel);
    if (booth.tab.textLabel == "new booth ") {
      console.log("new booth ");
      this.booth_register_mode = true;
      this.code_generated = false;
      this.booth_register_form.reset();
      this.deposit_receipt_image = null;
      this.nominee_image = null;
      this.booth_register_form.get("working_hours_from").setValue("09:00");
      this.booth_register_form.get("working_hours_to").setValue("06:00");
    } else {
      console.log("get_data");
      this.code_generated = true;
      this.booth_register_mode = false;
      this.getBoothData(booth.tab.textLabel);
    }
  }

  getFormData() {
    const data_dict = {
      agent_code: this.entered_agent_code,
    };
    this.http
      .getNomineeAndBankInfoForAgentUpdate(data_dict)
      .subscribe((data) => {
        console.log(data);
        console.info(data);

        // Map API response to form controls
        this.agent_register_form.patchValue({
          agent_gst_number: data["agent_gst_number"] || "",
          agent_id: data["agent_id"] || null,
          agent_profile_id: data["agent_profile_id"] || null,
          first_name: data["agent_first_name"] || "",
          last_name: data["agent_last_name"] || "",
          union_id: data["agent_union_id"] || null,
          gender_id: data["agent_gender_id"] || null,
          street: data["agent_street"] || "",
          taluk_id: data["agent_taluk_id"] || null,
          district_id: data["agent_distict_id"] || null,
          state_id: data["agent_state_id"] || null, // Default state_id to 1
          pincode: data["agent_pincode"] || "",
          mobile: data["agent_mobile"] || "",
          alternate_mobile: data["agent_alternate_mobile"] || "",
          communication_address: data["agent_communication_address"] || "",
          aadhar_document: data["aadhar_document"] || null,
          aadhar_number: data["agent_aadhar_number"] || "",
          pan_number: data["agent_pan"] || "",
          ration_card_number: data["agent_ration_card_number"] || "",
          bank_name: data["agent_bank"] || "",
          branch_name: data["agent_branch"] || "",
          ifsc_code: data["agent_ifsc_code"] || "",
          micr_code: data["agent_micr_code"] || "",
          account_holder_name: data["agent_account_holder_name"] || "",
          account_number: data["agent_account_number"] || "",
          gst_number: data["agent_gst_number"] || null,
        });

        // Sanitize and assign images
        this.image = this.sanitizer.bypassSecurityTrustResourceUrl(
          "data:image/png;base64," + (data["agent_image"] || "no_image")
        );
        this.aadhar_document = this.sanitizer.bypassSecurityTrustResourceUrl(
          "data:image/png;base64," + (data["aadhar_document"] || "no_image")
        );
        if (data["business_linked"] === true) {
          this.multiple_booth_list = data["business_codes"];
          // this.multiple_booth_list = data['business_codes'].concat(this.multiple_booth_list);
          console.log(this.multiple_booth_list);
          this.code_generated = true;
          this.booth_register_form
            .get("id")
            .setValue(data["business_data"]["business_id"]);
          this.booth_register_form
            .get("name")
            .setValue(data["business_data"]["name"]);
          this.booth_register_form
            .get("code")
            .setValue(data["business_data"]["code"]);
          this.booth_register_form
            .get("zone_id")
            .setValue(data["business_data"]["zone_id"]);
          this.booth_register_form
            .get("business_type_id")
            .setValue(data["business_data"]["business_type_id"]);
          this.booth_register_form
            .get("constituency_id")
            .setValue(data["business_data"]["constituency_id"]);
          this.booth_register_form
            .get("ward_id")
            .setValue(data["business_data"]["ward_id"]);
          this.booth_register_form
            .get("address")
            .setValue(data["business_data"]["address"]);
          this.booth_register_form
            .get("location_category_id")
            .setValue(data["business_data"]["location_category_id"]);
          this.booth_register_form
            .get("pincode")
            .setValue(data["business_data"]["pincode"]);
          this.booth_register_form
            .get("location_category_value")
            .setValue(data["business_data"]["location_category_value"]);
          this.booth_register_form
            .get("landmark")
            .setValue(data["business_data"]["landmark"]);
          this.booth_register_form.get("working_hours_from").setValue("09:00");
          this.booth_register_form.get("working_hours_to").setValue("06:00");
          this.booth_register_form
            .get("nominee_first_name")
            .setValue(data["business_data"]["nominee_first_name"]);
          this.booth_register_form
            .get("nominee_last_name")
            .setValue(data["business_data"]["nominee_last_name"]);
          this.booth_register_form
            .get("nominee_relation_type_id")
            .setValue(data["business_data"]["nominee_relation_type_id"]);
          this.booth_register_form
            .get("nominee_aadhar_number")
            .setValue(data["business_data"]["nominee_aadhar_number"]);
          this.booth_register_form
            .get("nominee_phone")
            .setValue(data["business_data"]["nominee_phone"]);
          this.booth_register_form
            .get("deposit_date")
            .setValue(data["business_data"]["deposit_date"]);
          this.booth_register_form
            .get("deposit_amount")
            .setValue(data["business_data"]["deposit_amount"]);
          this.booth_register_form
            .get("morg_route_id")
            .setValue(data["business_data"]["morg_route_id"]);
          this.booth_register_form
            .get("eve_route_id")
            .setValue(data["business_data"]["eve_route_id"]);

          // tslint:disable-next-line: max-line-length
          this.deposit_receipt_image =
            this.sanitizer.bypassSecurityTrustResourceUrl(
              "data:image/png;base64," +
                data["business_data"]["deposit_receipt_image"]
            );

          if (data["business_data"]["nominee_image"] != "no_image") {
            // tslint:disable-next-line: max-line-length
            this.nominee_image = this.sanitizer.bypassSecurityTrustResourceUrl(
              "data:image/png;base64," + data["business_data"]["nominee_image"]
            );
          }
          if (data["business_data"]["is_rural"]) {
            this.booth_register_form.get("is_rural").setValue(true);
          } else {
            this.booth_register_form.get("is_rural").setValue(false);
          }
        } else {
          this.booth_register_mode = true;
          this.action = "register";
          this.code_generated = false;
        }
      });
  }

  getBoothData(booth_code) {
    const data_dict = {
      booth_code: booth_code,
    };
    console.log(data_dict);
    this.http.getBoothDetailsForUpdate(data_dict).subscribe((data) => {
      console.log(data);
      this.booth_register_form.get("id").setValue(data["business_id"]);
      this.booth_register_form.get("name").setValue(data["name"]);
      this.booth_register_form.get("code").setValue(data["code"]);
      this.booth_register_form.get("zone_id").setValue(data["zone_id"]);
      this.booth_register_form
        .get("business_type_id")
        .setValue(data["business_type_id"]);
      this.booth_register_form
        .get("constituency_id")
        .setValue(data["constituency_id"]);
      this.booth_register_form.get("ward_id").setValue(data["ward_id"]);
      this.booth_register_form.get("address").setValue(data["address"]);
      this.booth_register_form
        .get("location_category_id")
        .setValue(data["location_category_id"]);
      this.booth_register_form.get("pincode").setValue(data["pincode"]);
      this.booth_register_form
        .get("location_category_value")
        .setValue(data["location_category_value"]);
      this.booth_register_form.get("landmark").setValue(data["landmark"]);
      this.booth_register_form.get("working_hours_from").setValue("09:00");
      this.booth_register_form.get("working_hours_to").setValue("06:00");
      this.booth_register_form
        .get("nominee_first_name")
        .setValue(data["nominee_first_name"]);
      this.booth_register_form
        .get("nominee_last_name")
        .setValue(data["nominee_last_name"]);
      this.booth_register_form
        .get("nominee_relation_type_id")
        .setValue(data["nominee_relation_type_id"]);
      this.booth_register_form
        .get("nominee_aadhar_number")
        .setValue(data["nominee_aadhar_number"]);
      this.booth_register_form
        .get("nominee_phone")
        .setValue(data["nominee_phone"]);
      // this.booth_register_form.get('nominee_image').setValue(data['nominee_image']);
      this.booth_register_form
        .get("deposit_date")
        .setValue(data["deposit_date"]);
      this.booth_register_form
        .get("deposit_amount")
        .setValue(data["deposit_amount"]);
      // this.booth_register_form.get('deposit_receipt_image').setValue(data['deposit_receipt_image']);
      this.booth_register_form
        .get("morg_route_id")
        .setValue(data["morg_route_id"]);
      this.booth_register_form
        .get("eve_route_id")
        .setValue(data["eve_route_id"]);

      // tslint:disable-next-line: max-line-length
      this.deposit_receipt_image =
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "data:image/png;base64," + data["deposit_receipt_image"]
        );

      // tslint:disable-next-line: max-line-length
      if (data["nominee_image"] != "no_image") {
        this.nominee_image = this.sanitizer.bypassSecurityTrustResourceUrl(
          "data:image/png;base64," + data["nominee_image"]
        );
      }
      if (data["is_rural"]) {
        this.booth_register_form.get("is_rural").setValue(true);
      } else {
        this.booth_register_form.get("is_rural").setValue(false);
      }
    });
  }

  allowPermission(label) {
    console.info(label);
    console.info(this.agent_edit_control[label]);
    this.agent_edit_control[label] = !this.agent_edit_control[label];
  }

  access(value) {
    return value;
  }

  updateAgentField(field, value, modal) {
    console.log(field);
    console.log(value);
    const data_dict = {
      field: field,
      value: value,
      agent_id: this.agent_register_form.value.agent_id,
    };

    if (field == "agent_image") {
      data_dict["value"] = this.image;
    }

    if (field == "aadhar_document") {
      data_dict["value"] = this.aadhar_document;
    }
    console.log(data_dict);
    this.http.saveIndividualFieldInAgentBooth(data_dict).subscribe((data) => {
      this.allowPermission(field);
      this.global.showSnakeBar("Field Updated success");
      console.log(data);
    });
  }

  updateBusinessField(field, value, modal) {
    console.log(field);
    console.log(value);
    const data_dict = {
      field: field,
      value: value,
      business_id: this.booth_register_form.value.id,
    };

    if (field == "deposit_receipt_image") {
      data_dict["value"] = this.deposit_receipt_image;
    }

    if (field == "nominee_image") {
      data_dict["value"] = this.nominee_image;
    }

    console.log(data_dict);
    this.http.saveIndividualFieldInAgentBooth(data_dict).subscribe((data) => {
      this.allowPermission(field);
      this.global.showSnakeBar("Field Updated success");
      console.log(data);
    });
  }
}
